import { connect, MapStateToProps } from 'react-redux';
import { Props } from './GroupsList';
import { getGroupsStream } from '../../redux/selectors';
import { AddToGroupsPanelStoreSlice } from '../../redux/types';

type StateProps = Pick<Props, 'streamId' | 'groups' | 'isFetching'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AddToGroupsPanelStoreSlice
> = state => ({
  ...getGroupsStream(state),
});

export default connect(mapStateToProps);
